import { css } from 'styled-components'

import { desktopVw } from '../../styles/utils'

export const accountStyleCTAButton = css`
  display: inline-flex;
  width: 100%;
  background-color: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.secondary};
  font-family: ${props => props.theme.fonts.grosa};
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  border-radius: 100px;
  text-transform: uppercase;
  letter-spacing: 1px;
  justify-content: center;
  align-items: center;
  height: 52px;

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    font-size: ${desktopVw(14)};
    line-height: ${desktopVw(20)};
    height: ${desktopVw(60)};
  }
`
